export default {
  sportsbook: "スポーツブック代理店",
  login_page: "スポーツブック代理店サイト",
  first_time_page: "初回ログイン",
  security_page: "セキュリティ認証",
  account_settings: "アカウント設定",
  new_login: "新規ログイン",
  two_step_verification: "二段階認証",
  account_information: "アカウント情報",
  commission_settings: "コミッション設定",
  bet_limit_settings: "ベット制限設定",
  position_taking_settings: "ポジション設定",
  update_profile: "プロフィール更新",
  update_password: "パスワード更新",
  update_security: "セキュリティ更新",
  account_profile: "アカウントプロフィール",
  account_creation: "アカウント作成",
  profile_settings: "プロフィール設定"
};